module.exports = __webpack_public_path__ + "img/roundJobDp.b892c983.svg";